import { IconProps } from "../../types/IconType";

const CloseIcon = ({ width, height, color = "#ffffff" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.56644 0.851424C5.40798 0.692964 5.152 0.692964 4.99354 0.851424L3.0067 2.8342L1.01986 0.84736C0.861403 0.688901 0.605429 0.688901 0.44697 0.84736C0.28851 1.00582 0.28851 1.26179 0.44697 1.42025L2.43381 3.40709L0.44697 5.39393C0.28851 5.55239 0.28851 5.80837 0.44697 5.96683C0.605429 6.12529 0.861403 6.12529 1.01986 5.96683L3.0067 3.97999L4.99354 5.96683C5.152 6.12529 5.40798 6.12529 5.56644 5.96683C5.7249 5.80837 5.7249 5.55239 5.56644 5.39393L3.5796 3.40709L5.56644 1.42025C5.72083 1.26586 5.72083 1.00582 5.56644 0.851424Z"
        fill={color}
      />
    </svg>
  );
};

export default CloseIcon;
